import { walletServices } from '@/services';

const {
  getWalletTransactionHistory,
  exportWalletTransactionHistory,
  addWalletTransaction,
  addNewVirtualAccount,
  getTransferRecipients,
  approvePayoutAccount,
  rejectPayoutAccount,
  activatePayoutAccount,
  createTransferRecipient,
  verifyRecipientAccount,
} = walletServices;

export default {
  namespaced: true,
  state: () => ({
    currentCompanyWallet: null,
  }),
  getters: {
    currentCompanyWallet: ({ currentCompanyWallet }) => currentCompanyWallet,
  },
  mutations: {
    SET_COMPANY_WALLET: (state, data) => {
      state.currentCompanyWallet = data;
    },
  },
  actions: {
    async getWalletHistory({ dispatch }, payload) {
      try {
        const { data } = await getWalletTransactionHistory(
          payload.walletId,
          payload.query?.search || ''
        );

        return data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
      }
    },
    async exportWalletTransactions({ dispatch }, payload) {
      try {
        const data = await exportWalletTransactionHistory(
          payload.EndAt,
          payload.Format,
          payload.StartAt,
          payload.Search,
          payload.walletId
        );

        return data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
      }
    },
    async makeCreditOrDebitTransaction({ dispatch }, payload) {
      try {
        const { data, status } = await addWalletTransaction(payload);

        if (status === 201) {
          dispatch(
            'notifications/displayNotification',
            {
              message: 'Transaction initiated',
              type: 'success',
            },
            { root: true }
          );
        }

        return data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
      }
    },
    async createNewVirtualAccountOnWallet({ dispatch }, payload) {
      try {
        const walletId = payload.walletId;
        const requestBody = {
          currency: payload.currency,
          provider: payload.provider,
          businessId: payload.businessId,
        };

        const { data, status } = await addNewVirtualAccount(walletId, requestBody);

        if (status === 201 || status === 200) {
          dispatch(
            'notifications/displayNotification',
            {
              message: 'New virtual account added to wallet successfully',
              type: 'success',
            },
            { root: true }
          );
        }

        return data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
      }
    },

    async getTransferRecipients({ dispatch }, { userId, walletId }) {
      try {
        const { data } = await getTransferRecipients(userId, walletId);
        return data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
      }
    },
    async approvePayoutAccount({ dispatch }, { accountId, otpCode }) {
      try {
        const { data } = await approvePayoutAccount(accountId, { otpCode });
        dispatch(
          'notifications/displayNotification',
          { message: 'Payout account approved successfully', type: 'success' },
          { root: true }
        );
        return data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
      }
    },
    async rejectPayoutAccount({ dispatch }, { accountId, otpCode }) {
      try {
        const { data } = await rejectPayoutAccount(accountId, { otpCode });
        dispatch(
          'notifications/displayNotification',
          { message: 'Payout account rejected successfully', type: 'success' },
          { root: true }
        );
        return data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
      }
    },
    async activatePayoutAccount({ dispatch }, { accountId, walletId, otpCode }) {
      try {
        const { data } = await activatePayoutAccount(accountId, { walletId, otpCode });
        dispatch(
          'notifications/displayNotification',
          { message: 'Payout account activated successfully', type: 'success' },
          { root: true }
        );
        return data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
      }
    },
    async createTransferRecipient({ dispatch }, payload) {
      try {
        const { data, status } = await createTransferRecipient(payload);
        if (status === 201 || status === 200) {
          dispatch(
            'notifications/displayNotification',
            { message: 'Payout account created successfully', type: 'success' },
            { root: true }
          );
        }
        return data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
      }
    },
    async verifyRecipientAccount({ dispatch }, payload) {
      try {
        const { data } = await verifyRecipientAccount(payload);
        return data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
      }
    },
  },
};
